import { render, staticRenderFns } from "./DataMarketplace.vue?vue&type=template&id=5c3951eb&"
import script from "./DataMarketplace.vue?vue&type=script&lang=ts&"
export * from "./DataMarketplace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports